const loadProject = ($template, data) => {    
    const $clone = $template.content.cloneNode(true);

    /* UI */
    const $root = $clone.querySelector("[data-template='root']");
    const $image = $clone.querySelector("[data-template='image']");
    const $title = $clone.querySelector("[data-template='title']");
    const $stats = $clone.querySelector("[data-template='stats']");
    const $statItem = $clone.querySelector("[data-template='stat']");
    const $tags = $clone.querySelector("[data-template='tags']");
    const $tagItem = $clone.querySelector("[data-template='tag']");
    const $linkWrapper = $clone.querySelector("[data-template='link']");
    const $arrow = $clone.querySelector("[data-template='arrow']");

    /* Image */

    if (data.image.src) {
        const $imageEl = $image.querySelector('img');
        $imageEl.src = data.image.src;
        $imageEl.alt = data.image.alt;
        $imageEl.width = data.image.width;
        $imageEl.height = data.image.height;
    } else {
        $image.remove();
    }

    /* Title */
    $title.innerHTML = data.title;

    /* Stats */
    $statItem.remove();

    data.stats.forEach((stat) => {
        const $stat = $statItem.cloneNode(true);
        const $label = $stat.querySelector("[data-template='label']");
        const $value = $stat.querySelector("[data-template='value']");
        $label.innerHTML = stat.label;
        $value.innerHTML = stat.value;
        $stats.appendChild($stat);
    });

    /* Tags */
    $tagItem.remove();

    data.tags.forEach((tag) => {
        const $tag = $tagItem.cloneNode(true);
        const $label = $tag.querySelector("[data-template='label']");
        $label.innerHTML = tag;
        $tags.appendChild($tag);
    });

    /* Link (also the title)*/
    $linkWrapper.replaceChildren();
    
    if (data.cta && data.cta.url) {
        const $link = document.createElement('a');
        $link.className = 'c-tile-project_link';
        $link.href = data.cta.url;

        if (data.cta.isExternal) {
            $link.target = '_blank';
            $link.rel = 'noopener noreferrer';
        } else {
            $link.target = '_self';
        }
        
        const span = document.createElement('span');
        span.className = 'u-screen-reader-text';
        span.setAttribute('data-template', 'label');
        span.textContent = data.title;
        
        $link.appendChild(span);
        $linkWrapper.appendChild($link);

    } else {
        const $a11Title = document.createElement('span');
        $a11Title.className = 'u-screen-reader-text';
        $a11Title.textContent = data.title;
        $linkWrapper.appendChild($a11Title);
        $root.classList.remove('-link');
        $arrow.remove();
    }

    return $clone;
};

export default loadProject;
